export const routes = [
  { id: 1, name: "Home", path: "/" },
  { id: 2, name: "Formik Project", path: "/formik-project" },
  { id: 3, name: "Formik SignIn", path: "/formik-signin" },
  { id: 4, name: "Formik Text Field", path: "/formik-textfield" },
  { id: 5, name: "Formik Field", path: "/formik-field" }
];
